import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import { InvoiceDetailsPageContext } from "@insite/content-library/Pages/InvoiceDetailsPage";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { FC, useContext } from "react";

export interface InvoiceToOrderLinksStyles {
    linksGridItem: GridItemProps;
    title: TypographyProps;
}

const styles: InvoiceToOrderLinksStyles = {
    linksGridItem: {
        width: [6, 4, 3, 2, 2],
    },
    title: {
        variant: "h6",
        as: "h2",
    },
};

export const linksStyles = styles;

interface Props extends WidgetProps {}

const InvoiceToOrderLinks: FC<Props> = props => {
    const { value: invoice } = useContext(InvoiceStateContext);
    if (
        !invoice ||
        !invoice.invoiceLines ||
        !invoice.invoiceLines.some(invoiceLine => {
            return invoiceLine.erpOrderNumber;
        })
    ) {
        return null;
    }
    const orderNumbers: Array<string> = [];
    for (const invoiceLine of invoice.invoiceLines) {
        if (invoiceLine.erpOrderNumber && !orderNumbers.includes(invoiceLine.erpOrderNumber)) {
            orderNumbers.push(invoiceLine.erpOrderNumber);
        }
    }
    const orderLinks = [];
    for (const orderNumber of orderNumbers) {
        orderLinks.push(
            <GridItem {...styles.linksGridItem}>
                <OrderDetailPageTypeLink title={orderNumber} orderNumber={orderNumber} />
            </GridItem>,
        );
    }
    return (
        <section>
            <Typography {...styles.title}>{`${translate("Related Orders")}`}</Typography>
            <GridContainer>{orderLinks}</GridContainer>
        </section>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceToOrderLinks,
    definition: {
        allowedContexts: ["InvoiceDetailsPage"],
        group: "Invoice History",
    },
};

export default widgetModule;
